import { useEffect, useState } from "react";
import { PauseCircle } from "lucide-react";
import api from "@/lib/api";

export const MaintenanceBanner = () => {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    api.get("/rental-status").then((r) => setStatus(r.data)).catch(() => {});
  }, []);

  if (!status?.paused) return null;

  return (
    <div className="bg-amber-400 text-ink" data-testid="rentals-paused-banner">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-3 px-4 py-3 text-center sm:px-8">
        <PauseCircle className="h-5 w-5 shrink-0" aria-hidden />
        <p className="text-sm font-semibold" data-testid="rentals-paused-text">{status.message}</p>
      </div>
    </div>
  );
};
